module.exports = __webpack_public_path__ + "img/poliglotk.26399b6d.jpg";